var isArray = Array.isArray;
const isArray$1 = isArray;
export {
  isArray$1 as default
};
